<template>
  <div>
    <v-row dense>
      <v-col cols='12'>
        <wc-datepicker v-model='value.project_detail.install_date' label='Install date'></wc-datepicker>
        <v-checkbox v-if='value.is_comm' hide-details v-model='value.project_detail.has_meter_pit' label='Meter Pit?'></v-checkbox>
        <v-checkbox hide-details v-model='value.project_detail.is_hose_bib' label='Hose Bib Job? (main supply not plumbed)'></v-checkbox>
        <v-checkbox hide-details v-model='value.project_detail.has_charged_hose_bib' label='Charged line to hose bib?'></v-checkbox>
        <v-checkbox hide-details v-model='value.project_detail.has_charged_feature' label='Charged line to water feature?'></v-checkbox>
      </v-col>
    </v-row>
    <v-row class='mt-5'>
      <v-col cols='6'>
        <v-text-field
          label="Number of Zones"
          v-model='value.project_detail.num_zones'
        ></v-text-field>
      </v-col>
      <v-col cols='6'>
        <v-text-field
          label="Number of Heads"
          v-model='value.project_detail.num_heads'
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'

export default {
  name: 'irrigation-details-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  }
}
</script>
